import * as React from 'react'
import { components, MenuListProps } from 'react-select'

function OrderMenuWrapper(props: MenuListProps<any, false>) {
  return (
    <components.MenuList {...props}>
      <table className="table table-sm">
        <thead>
          <tr>
            <th />
            <th>ID</th>
            <th>Tilbudsnr.</th>
            <th>Ordrenr.</th>
            <th>Jobnavn</th>
            <th>Kundenavn</th>
          </tr>
        </thead>
        <tbody>{props.children}</tbody>
      </table>
    </components.MenuList>
  )
}

export default OrderMenuWrapper
